import { useRouter } from "next/router";
import { createContext, useContext } from "react";
import { useAnalytics } from "services/analytics.service";

interface AnalyticsContextInterface {
  page: any;
  track: any;
  identify: any;
  reset: any;
  hasLoaded: boolean;
  hasLoadedFeatureFlags: boolean;
}

const AnalyticsContext = createContext<AnalyticsContextInterface | undefined>(
  undefined
);

export const useAnalyticsContext = () => {
  const context = useContext(AnalyticsContext);
  if (context === undefined) {
    throw new Error(
      "AnalyticsContext must be used within a AnalyticsContextProvider"
    );
  }
  return context;
};

export const AnalyticsContextProvider = ({
  children,
}: React.PropsWithChildren<{}>) => {
  const router = useRouter();

  const {
    page,
    track,
    identify,
    reset,
    hasLoaded,
    hasLoadedFeatureFlags,
    posthog,
  } = useAnalytics();

  return (
    <AnalyticsContext.Provider
      value={{
        page,
        track,
        identify,
        reset,
        hasLoaded,
        hasLoadedFeatureFlags,
      }}
    >
      {children}
    </AnalyticsContext.Provider>
  );
};
